import { INavigation } from "Utils/Interfaces";
import { useEffect } from "react";
import styles from "./Navigation.module.scss";

export default function Navigation(props: INavigation) {

  useEffect(() => {

    if(props.local) return;

    setTimeout(() => {
      window.open(props.url, "_blank");
    }, 500);
  }, [props]);
  

  return (
      <div className={styles.container}>
          <div className="">{props.title}</div>
          <a href={props.url} target="_blank" rel="noopener noreferrer" className={styles.link}>{props.urlTitle}</a>
      </div>
  )
}
